import './gb-refinement-list.tag.html';
import './gb-available-refinement.tag.html';
import './gb-selected-refinement.tag.html';
import { Navigation } from './gb-navigation';
riot.tag2('gb-navigation', '<yield> <div class="gb-side-nav {_style}"> <gb-refinement-list each="{nav in processed}"></gb-refinement-list> </div> </yield>', 'gb-navigation .gb-stylish.gb-side-nav,[riot-tag="gb-navigation"] .gb-stylish.gb-side-nav,[data-is="gb-navigation"] .gb-stylish.gb-side-nav{ padding: 12px; }', '', function(opts) {
    this._mixin(Navigation);
});



/** WEBPACK FOOTER **
 ** ./src/tags/navigation/gb-navigation.tag.html
 **/